import LandingHeader from "@/components/landing/LandingHeader";
import LandingHero from "@/components/landing/LandingHero";
import LandingTicker from "@/components/landing/LandingTicker";
import LandingWhySection from "@/components/landing/LandingWhySection";
import LandingFlowSection from "@/components/landing/LandingFlowSection";
import LandingTiersSection from "@/components/landing/LandingTiersSection";
import LandingRequestAccessSection from "@/components/landing/LandingRequestAccessSection";
import LandingClosingCTA from "@/components/landing/LandingClosingCTA";
import LandingFooter from "@/components/landing/LandingFooter";

/**
 * Public marketing landing page for BulkBuyKits.com
 * Sections are built modularly under /components/landing/* and composed here.
 * This page intentionally does NOT include the app shell (Nav, DisclaimerBanner, etc.).
 *
 * iter_142 — WelcomePopup is now mounted globally in App.js so the tab and
 * popup appear on every route, not just landing.
 */
export default function Landing() {
  return (
    <div className="min-h-screen bg-bone text-charcoal" data-testid="landing-page">
      <LandingHeader />
      <main>
        <LandingHero />
        <LandingTicker />
        <LandingWhySection />
        <LandingFlowSection />
        <LandingTiersSection />
        <LandingRequestAccessSection />
        <LandingClosingCTA />
      </main>
      <LandingFooter />
    </div>
  );
}
